// extracted by mini-css-extract-plugin
export default {"selectReport":"style_selectReport__bztaf","titleSelect":"style_titleSelect__-GSQL","select":"style_select__L1nbP"};